// @ts-ignore
import Text from '../../Base/Text/Text';
import 'react-datepicker/dist/react-datepicker.css';
// @ts-ignore
import styles from './Select.module.scss';
import TextField from '../TextField/TextField';
import * as React from 'react';
import { useEffect, useState } from 'react';

interface BMIProps {
	weight?: number;
	height?: number;
	onChange?: (bmi: number) => void;
}

const BMI: React.FC<BMIProps> = props => {
	const { onChange } = props;
	let { weight, height } = props;
	const [tempValue, setTempValue] = useState<number>(0);

	useEffect(() => {
		calculate();
	}, [weight, height]);

	const calculate = () => {
		let bmi = 0;

		if (weight && height) {
			const heightCm = height / 100;
			bmi = +(weight / (heightCm * heightCm)).toFixed(2);
		}

		onChange?.(bmi);
		setTempValue(bmi);
	};

	return (
		<div className='d-flex flex-row align-items-center' style={{ gap: '15px' }}>
			<TextField
				suffix={'kg/m2'}
				disabled={true}
				value={tempValue?.toString()}
			/>
		</div>
	);
};

export default BMI;
